export enum QuackField {
  TOPIC = 'TOPIC',
  RESOLUTION_STATUS = 'RESOLUTION_STATUS',
  RESOLUTION_STATUS_REASON = 'RESOLUTION_STATUS_REASON',
  AI_AGENT = 'AI_AGENT',
  ENRICHMENT = 'ENRICHMENT',
}

export enum MappingType {
  CUSTOM_FIELD = 'CUSTOM_FIELD',
  TAG = 'TAG',
  STANDARD_FIELD = 'STANDARD_FIELD',
}

export interface FieldSyncConfiguration {
  id: string;
  tenantId: string;
  quackField: QuackField;
  mappingType: MappingType;
  targetFieldId?: string;
  targetFieldName: string;
  enrichmentId?: string;
  enrichment?: {
    id: string;
    name: string;
  };
  options?: Record<string, any>;
  isEnabled: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface AvailableField {
  id: string;
  name: string;
  type: string;
  description?: string;
}

export interface CreateFieldSyncConfigurationDto {
  quackField: QuackField;
  mappingType: MappingType;
  targetFieldId?: string;
  targetFieldName: string;
  enrichmentId?: string;
  options?: Record<string, any>;
}

export interface UpdateFieldSyncConfigurationDto {
  targetFieldId?: string;
  targetFieldName?: string;
  isEnabled?: boolean;
  options?: Record<string, any>;
}

export interface SyncResult {
  configurationId: string;
  quackField: QuackField;
  status: 'SUCCESS' | 'FAILED';
  quackFieldValue: string;
  targetFieldId: string;
  targetFieldValue: string;
  error?: string;
}

export const QUACK_FIELD_LABELS: Record<QuackField, string> = {
  [QuackField.TOPIC]: 'Topic',
  [QuackField.RESOLUTION_STATUS]: 'Resolution Status',
  [QuackField.RESOLUTION_STATUS_REASON]: 'Resolution Status Reason',
  [QuackField.AI_AGENT]: 'AI Agent',
  [QuackField.ENRICHMENT]: 'Enrichment',
};

export const MAPPING_TYPE_LABELS: Record<MappingType, string> = {
  [MappingType.CUSTOM_FIELD]: 'Custom Field',
  [MappingType.TAG]: 'Tag',
  [MappingType.STANDARD_FIELD]: 'Standard Field',
};
